import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { Publication } from "../../types/app";

export interface PopulateState {
  populateEngine: "Google Scholar" | "Science Direct";
  populateQuery: string;
  publications: Publication[];
  selectedPublications: number[];
}

const initialState: PopulateState = {
  populateEngine: "Google Scholar",
  populateQuery: "",
  publications: [],
  selectedPublications: [],
};

export const populateResetAll = createAction("RESET_ALL");

export const populateSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setPopualateEngine: (
      state,
      action: PayloadAction<"Google Scholar" | "Science Direct">
    ) => {
      state.populateEngine = action.payload;
    },
    setPopulateQuery: (state, action: PayloadAction<string>) => {
      state.populateQuery = action.payload;
    },
    setPublications: (state, action: PayloadAction<Publication[]>) => {
      state.publications = action.payload;
    },
    refreshSelectedPublications: (state) => {
      state.selectedPublications = [];
    },
    addSelectedPublication: (state, action: PayloadAction<number>) => {
      state.selectedPublications = [
        ...state.selectedPublications,
        action.payload,
      ];
    },
    deleteSelectedPublication: (state, action: PayloadAction<number>) => {
      state.selectedPublications = state.selectedPublications.filter(
        (idx) => idx !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(populateResetAll, () => initialState);
  },
});

export const {
  setPopualateEngine,
  setPopulateQuery,
  setPublications,
  refreshSelectedPublications,
  addSelectedPublication,
  deleteSelectedPublication,
} = populateSlice.actions;

export default populateSlice.reducer;
